import { Navbar } from "flowbite-react";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import logo from "../../img/logo.svg";
import {
  getSessionExpiredContext,
  logSessionExpired,
} from "../../utils/sessionExpired";

const InvalidPage = () => {
  const location = useLocation();

  useEffect(() => {
    const context =
      location.state || getSessionExpiredContext() || {
        reason: "unknown",
        source: "InvalidPage",
      };
    logSessionExpired(context);
    console.log("Session expired", context);
  }, [location.state]);

  return (
    <>
      <Navbar fluid={true} rounded={true} className="shadow mb-3">
        <Navbar.Brand>
          <img src={logo} className="mr-3 ml-2 h-8 sm:h-10" alt="Ryde" />
          <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">
            Session Expired
          </span>
        </Navbar.Brand>
        <div className="flex md:order-2"></div>
      </Navbar>
    </>
  );
};

export default InvalidPage;
